import { type FC } from 'react';
import { Grid, Stack } from '@mantine/core';
import { CascadeGroupDangerZone } from './components/CascadeGroupDangerZone';
import { CascadeGroupEditorHeader } from './components/CascadeGroupEditorHeader';
import { CascadeGroupInfoCard } from './components/CascadeGroupInfoCard';
import { useCascadeGroupEditor } from './lib';

interface CascadeGroupEditorProps {
    id?: string;
}

export const CascadeGroupEditor: FC<CascadeGroupEditorProps> = ({ id }) => {
    const editor = useCascadeGroupEditor(id);

    return (
        <Stack gap='md'>
            <CascadeGroupEditorHeader
                isNew={editor.isNew}
                groupId={id}
            />

            <Grid gap='md'>
                <Grid.Col span={{ base: 12, md: 8 }}>
                    <CascadeGroupInfoCard
                        form={editor.form}
                        tradersOptions={editor.tradersOptions}
                        isTradersLoading={editor.isTradersLoading}
                        currentTraders={editor.currentTraders}
                        isSubmitPending={editor.isSubmitPending}
                        onSubmit={editor.handleSubmit}
                    />
                </Grid.Col>

                {!editor.isNew && (
                    <Grid.Col span={{ base: 12, md: 4 }}>
                        <CascadeGroupDangerZone
                            isPending={editor.isDeletePending}
                            onDelete={editor.handleDelete}
                        />
                    </Grid.Col>
                )}
            </Grid>
        </Stack>
    );
};
